import { createSlice } from "@reduxjs/toolkit";

export interface CookieSettingsSlice {
    overlayIsOpen: boolean;
}

const cookieSettings = createSlice({
    name: "cookieSettings",
    initialState: {
        overlayIsOpen: false,
    } as CookieSettingsSlice,
    reducers: {
        openOverlay(state): void {
            state.overlayIsOpen = true;
        },
        closeOverlay(state): void {
            state.overlayIsOpen = false;
        },
    },
});

export const { openOverlay, closeOverlay } = cookieSettings.actions;
export default cookieSettings.reducer;
